import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaRecycle, FaUsers, FaLeaf, FaWater, FaLightbulb, FaTree } from 'react-icons/fa';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const sustainabilityPoints = [
  {
    icon: <FaUsers size={30} className="text-green-700" />,
    title: 'Apoyo a la Comunidad Local',
    description: 'Creemos en el crecimiento mutuo. Priorizamos la contratación de personal local y adquirimos nuestros insumos de productores y artesanos de la región, impulsando una economía circular y sostenible.',
  },
  {
    icon: <FaLeaf size={30} className="text-green-700" />,
    title: 'Construcción de Bajo Impacto',
    description: 'Nuestra infraestructura se integra armoniosamente con el paisaje. Utilizamos maderas certificadas y materiales de bajo impacto ambiental, respetando la topografía y la vegetación nativa que nos rodea.',
  },
  {
    icon: <FaRecycle size={30} className="text-green-700" />,
    title: 'Gestión Integral de Residuos',
    description: 'Contamos con un programa completo de gestión de residuos. Separamos y clasificamos materiales reciclables, y transformamos los desechos orgánicos en compost para nutrir nuestros jardines.',
  },
  {
    icon: <FaWater size={30} className="text-green-700" />,
    title: 'Conservación del Agua',
    description: 'El agua es un tesoro en la selva. Hemos implementado sistemas de ahorro en grifos y duchas, y procesamos nuestras aguas residuales para minimizar nuestro impacto en el ecosistema acuático.',
  },
  {
    icon: <FaLightbulb size={30} className="text-green-700" />,
    title: 'Uso Eficiente de la Energía',
    description: 'Toda la iluminación del hotel utiliza tecnología LED de bajo consumo. Maximizamos la luz natural y estamos en proceso de incorporar paneles solares para aprovechar la energía renovable del sol amazónico.',
  },
  {
    icon: <FaTree size={30} className="text-green-700" />,
    title: 'Protección de Flora y Fauna',
    description: 'Somos guardianes del ecosistema que nos acoge. Protegemos activamente los hábitats naturales y participamos en programas de reforestación para conservar y enriquecer la biodiversidad local.',
  },
];

const Sustainability = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50">
      <Navbar />
      
      <header 
        className="relative bg-cover bg-center pt-40 pb-24" 
        style={{ backgroundImage: `url(/images/cta-bg.jpg)` }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative container mx-auto px-4 text-center text-white">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-4xl sm:text-5xl md:text-6xl font-playfair font-bold"
          >
            Nuestro Compromiso Sostenible
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-4 text-lg max-w-3xl mx-auto"
          >
            En Sumaq Mayu, el verdadero lujo es el respeto por nuestro entorno. Conoce cómo trabajamos para proteger la invaluable selva que nos acoge.
          </motion.p>
        </div>
      </header>

      <main className="py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
            {sustainabilityPoints.map((point, index) => (
              <motion.div
                key={point.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.7, delay: index * 0.1 }}
                className="bg-white p-8 rounded-2xl shadow-xl flex flex-col"
              >
                <div className="flex-shrink-0 mb-5 flex items-center justify-center h-16 w-16 bg-green-100 rounded-full">
                  {point.icon}
                </div>
                <div className="flex-grow">
                  <h3 className="text-2xl font-playfair font-semibold text-gray-800 mb-4">{point.title}</h3>
                  <p className="text-gray-700 leading-relaxed">{point.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Sustainability;

